// src/components/Course/StudentCourseList.tsx
import React, { useEffect, useState } from 'react';
import { getStudentActiveCourses } from '../../services/courseService';
import StudentCourseItem from './StudentCourseItem';
import { Course } from '../../types/interfaces';
import { Container, Grid, Typography, Box } from '@mui/material';
import { useAuth } from '../AuthContext';

const StudentCourseList: React.FC = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      if (!user?.email) return;
      
      try {
        const response = await getStudentActiveCourses(user.email);
        setCourses(response.data);
      } catch (error) {
        console.error('Failed to fetch courses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user?.email]);

  if (loading) {
    return <Typography>Ladataan kursseja...</Typography>;
  }

  if (courses.length === 0) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="h6" color="text.secondary">
          Sinulla ei ole aktiivisia kursseja tällä hetkellä.
        </Typography>
      </Box>
    );
  }

  return (
    <Container>
      <Grid container spacing={3}>
        {courses.map((course) => (
          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <StudentCourseItem course={course} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default StudentCourseList;
